<template>
  <v-layout class='redirect-container'>
      <button>
        <a href='https://apps.apple.com/br/app/super-comics/id1327984849?l'>
          <img src='../../public/img/app-store.webp' alt='Baixar para IOS' />
        </a>
      </button>
      <button>
        <a href='https://play.google.com/store/apps/details?id=com.zedlatam.supercomics&pcampaignid=web_share'>
          <img src='../../public/img/play-store.webp' alt='Baixar para Android' />
        </a>
      </button>
  </v-layout>
</template>

<script>
export default {
  name: 'Redirecionar',
  mounted() {
    const plataforms = ['iPhone', 'iPad', 'iPod'];

    if (plataforms.includes(navigator.platform)) {
      window.location.href = 'https://apps.apple.com/br/app/super-comics/id1327984849?l';
      return;
    }

    window.location.href = 'https://play.google.com/store/apps/details?id=com.zedlatam.supercomics&pcampaignid=web_share'
  }
};
</script>

<style>
.index-footer {
  position: absolute !important;
  bottom: 0 !important;
}

.redirect-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (max-width: 475px) {
    width: 80%;
  }
}
</style>